module.exports = __webpack_public_path__ + "static/img/logo_red_dang.70e73946.png";